import React from 'react'
import { Text } from '../../../generic'
import { car, house, emergency } from '../../../../images/savingsGoals'
import { happy, meh, sadRed } from '../../../../images/smily'
import cardImage from '../../../../images/card.png'
import { capitalizeWords } from '../../../../lib/utils'

const loanTypeIcons = {
  card: cardImage, // Credit card
  loan: emergency, // Personal loan
  home: house,
  car: car
}

const loanTypeLabels = {
  card: 'Credit Card',
  loan: 'Personal Loan',
  home: 'Home Loan',
  car: 'Car Loan'
}

const getSmileyIcon = (probability) => {
  if (probability >= 70) return happy // Green smiley
  if (probability >= 40) return meh // Yellow/neutral smiley
  return sadRed // Red sad face
}

function LoanLikelihood({ type, probability, label }) {
  if (!type || probability === undefined) return null

  const icon = loanTypeIcons[type]
  const typeLabel = loanTypeLabels[type] || type
  const smileyIcon = getSmileyIcon(probability)
  const percentage = Math.round(probability)

  return (
    <div style={{
      background: '#FFFFFF',
      boxShadow: 'inset 0px 0px 10px rgba(64, 67, 87, 0.08)',
      borderRadius: '4px',
      padding: '16px',
      marginBottom: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
        {icon && (
          <img
            src={icon}
            alt={typeLabel}
            style={{ width: '32px', height: '32px', margin: 0 }}
          />
        )}
        <div style={{ flex: 1 }}>
          <Text size={14} bold style={{ marginBottom: '2px' }}>
            {typeLabel}
          </Text>
          {label && (
            <Text size={12} color="grey4">
              {capitalizeWords(label)}
            </Text>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <Text size={16} bold color="primary">
          {percentage}%
        </Text>
        <img
          src={smileyIcon}
          alt="likelihood"
          style={{
            width: '24px',
            height: '24px',
            margin: 0
          }}
        />
      </div>
    </div>
  )
}

export default LoanLikelihood
